<section
  class="rich-content-wrapper"
  [ngClass]="{'paragraph-margin': showParagraphMargin}"
  [innerHTML]="content | sanitize"
  test-target="rich-content-wrapper"
></section>
